import React from 'react'
import debounce from 'lodash/debounce'
import { useDispatch } from 'react-redux'
import { reduxForm, Field, FieldArray } from 'redux-form'
import shortUUID from 'short-uuid'
import { inputTypes } from '@easybutton/constants'

import { saveInputs } from '../../../../ducks/actions'
import WrappedInput from '../../../Shared/Forms/WrappedInput'
import Button from '../../../Shared/Button'
import EmptyState from '../../../Shared/EmptyState'
import { IconButton } from '../../../Shared/Icon'
import Card from '../../../Shared/Card'
import TypeMenu from './TypeMenu'

import styles from './Inputs.module.css'

const FORM_NAME = 'editInputsForm'

const CONFIRM_MESSAGE = `Are you sure you want to delete this input?

This may affect action steps that use this input.`

const Item = function InputItem({ field, onRemove }) {
  const handleRemove = () => {
    if (!window.confirm(CONFIRM_MESSAGE)) {
      return
    }

    onRemove()
  }

  return (
    <div className={styles.item}>
      <Field
        name={`${field}.name`}
        component={WrappedInput}
        label="Name"
        className={styles.nameInput}
      />
      <Field name={field} component={TypeMenu} className={styles.type} />
      <div className={styles.delete}>
        <IconButton
          large
          icon="delete"
          onClick={handleRemove}
          color="lightGrey"
        />
      </div>
    </div>
  )
}

const Items = function ActionInputItems({ fields }) {
  const handleAdd = () => {
    fields.push({
      id: shortUUID.generate(),
      name: 'New Input',
      type: inputTypes.TEXT,
    })
  }

  if (fields.length === 0) {
    return (
      <EmptyState tight>
        <h2>No Inputs Yet</h2>
        <Button small color="grey" onClick={handleAdd} icon="add">
          Add Input
        </Button>
      </EmptyState>
    )
  }

  return (
    <>
      <div className={styles.inputs}>
        {fields.map((field, i) => (
          <Item field={field} key={field} onRemove={() => fields.remove(i)} />
        ))}
      </div>
      <Button small text type="button" icon="add" onClick={handleAdd}>
        Add Input
      </Button>
    </>
  )
}

const Form = function ActionInputForm({ inputs, handleSubmit, dirty }) {
  return (
    <form onSubmit={handleSubmit}>
      <FieldArray component={Items} name="inputs" />
    </form>
  )
}

const WrappedForm = reduxForm({
  form: FORM_NAME,
})(Form)

export default function ActionInputs({ action }) {
  const dispatch = useDispatch()

  const inputs = action.details.inputs || []

  const handleSubmit = values => {
    // Do nothing
  }

  const handleChange = debounce(({ inputs: newInputs }) => {
    if (JSON.stringify(inputs) !== JSON.stringify(newInputs)) {
      dispatch(saveInputs(action.id, newInputs))
    }
  }, 2000)

  return (
    <Card>
      <h2>Inputs</h2>
      <WrappedForm
        inputs={inputs}
        initialValues={{ inputs }}
        onSubmit={handleSubmit}
        onChange={handleChange}
      />
    </Card>
  )
}
